/**
 * RoundActionsBar
 *
 * Styled container for the action buttons row at the bottom of a round card.
 * Left side: destructive/state-changing actions (Delete, Edit, Disable).
 * Right side: lifecycle actions (Load, Unload, Start, End).
 */

import { ReactNode } from 'react';

interface RoundActionsBarProps {
  leftActions: ReactNode;
  rightActions: ReactNode;
}

export function RoundActionsBar({ leftActions, rightActions }: RoundActionsBarProps) {
  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-xs mt-xs pt-xs border-top border-md border-blue-light">
      <div className="d-flex flex-wrap gap-xs">{leftActions}</div>
      <div className="d-flex flex-wrap gap-xs">{rightActions}</div>
    </div>
  );
}
